import React from 'react';
import { ToggleGroupRoot } from '../../../atoms/ToggleGroupRoot/ToggleGroupRoot';
import { ToggleGroupItem } from '../../../atoms/ToggleGroupItem/ToggleGroupItem';

type ToggleGroupItem = {
  value: string;
  label: React.ReactNode;
  disabled?: boolean;
} & Omit<
  React.ComponentPropsWithoutRef<typeof ToggleGroupItem>,
  'position' | 'value'
>;

type ToggleGroupProps = React.ComponentPropsWithoutRef<
  typeof ToggleGroupRoot
> & {
  items: ToggleGroupItem[];
};

const getItemPosition = (
  index: number,
  totalItems: number,
): 'first' | 'middle' | 'last' => {
  if (index === 0) {
    return 'first';
  }

  if (index === totalItems - 1) {
    return 'last';
  }

  return 'middle';
};

export const ToggleGroup: React.FC<ToggleGroupProps> = ({
  items,
  ...props
}) => (
  <ToggleGroupRoot {...props}>
    {items.map(({ value, label, disabled, ...itemProps }, index) => (
      <ToggleGroupItem
        {...itemProps}
        key={value}
        value={value}
        disabled={disabled}
        position={getItemPosition(index, items.length)}
      >
        {label}
      </ToggleGroupItem>
    ))}
  </ToggleGroupRoot>
);
